import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import PropTypes from 'prop-types';

const ConfirmationDialog = ({ open, onClose, onConfirm }) => (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', pb: 2 }}>
        Confirm API Key Regeneration
      </DialogTitle>
      <DialogContent sx={{ px: 4, py: 2 }}>
        <Typography sx={{ textAlign: 'center', mb: 2 }}>
          Are you sure you want to regenerate your API key? The current API key will be invalidated, and a new one will be generated.
        </Typography>
        <Typography sx={{ textAlign: 'center', color: 'text.secondary', fontSize: 14 }}>
          Please note: Ensure that you update your applications with the new API key to avoid service disruption.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            px: 4,
            pb: 3,
          }}
        >

          <Button onClick={onConfirm} variant="contained" color='primary' >
            Confirm
          </Button>
          <Button onClick={onClose} variant="outlined" color="error" >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,         
  onClose: PropTypes.func.isRequired,      
  onConfirm: PropTypes.func.isRequired,    
};

export default ConfirmationDialog;
